import Image from '@/components/Image';
import useCurrentLoginUserInfo from '@/hooks/useCurrentLoginUserInfo';
import useThemeToken from '@/hooks/useTheme';
import { useLocales } from '@/Locales';
import { useCacheTab } from '@/store/cacheTab';
import { removeLocalStorage, removeToken, TOKEN_KEY } from '@/utils/cookies';
import { ExclamationCircleFilled, UserOutlined } from '@ant-design/icons';
import { Dropdown, Modal, Space } from '@sinohealth/butterfly-ui-components';
import { useAliveController } from 'react-activation';
import { useNavigate } from 'react-router-dom';
import styles from './index.less';

const UserInfo = () => {
  const themeToken = useThemeToken();
  const [userInfo] = useCurrentLoginUserInfo();
  const { t } = useLocales();
  const navigate = useNavigate();
  const { clearTabs } = useCacheTab();
  const { clear } = useAliveController();
  const handleMenuClick = (e: any) => {
    if (e.key === 'userCenter') {
      navigate('/personal/userinfo');
    }
    if (e.key === 'quitLogin') {
      Modal.confirm({
        title: t('确认退出当前账号?'),
        icon: <ExclamationCircleFilled />,
        content: t('退出将转跳登录页，需重新登录才可访问系统'),
        okButtonProps: {
          style: {
            height: 'auto',
            backgroundColor: themeToken.colorPrimary,
          },
        },
        cancelButtonProps: {
          style: {
            height: 'auto',
          },
        },
        onOk() {
          clearTabs();
          removeToken();
          removeLocalStorage(TOKEN_KEY);
          clear();
          navigate('/login');
        },
      });
    }
  };
  const items = [
    {
      key: 'userCenter',
      label: t('个人中心'),
    },
    {
      key: 'quitLogin',
      label: t('退出登录'),
    },
  ];
  return (
    <div className={styles.userInfo}>
      <div className={styles.avtar}>
        {userInfo.user?.avatar ? (
          <Image className={styles.avatarImg} width={32} height={32} src={userInfo.user?.avatar} />
        ) : (
          <UserOutlined />
        )}
      </div>
      <Dropdown menu={{ items, onClick: handleMenuClick }}>
        <Space>
          <span className={styles.userName} style={{ color: themeToken.colorText }}>
            {userInfo?.user?.realName}
          </span>
          <span
            className="iconfont icon-arrow-down-s-line"
            style={{ color: themeToken.colorText }}
          />
        </Space>
      </Dropdown>
    </div>
  );
};

export default UserInfo;
